import { useDropdown } from 'components/UI/V3/Dropdown/DropdownContext';
import React from 'react';

interface DropdownTriggerProps {
    children: React.ReactNode;
    className?: string;
    disabled?: boolean;
}

export const DropdownTrigger: React.FC<DropdownTriggerProps> = ({ children, className, disabled = false }) => {
    const { open, setOpen, triggerRef } = useDropdown();

    // Toggle rather than always-open so clicking the trigger while the dropdown
    // is open closes it (standard pattern shared with Radix / Material / Ant).
    // Without toggle, the ClickAwayListener inside DropdownContent flips open
    // to false on `mousedown`, then this handler flips it back to true on the
    // synthetic `click` — leaving the menu stuck open on second trigger click.
    const handleClick = () => {
        if (!disabled) {
            setOpen(!open);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!disabled) {
                setOpen(!open);
            }
        }
    };

    return (
        <div
            ref={triggerRef as React.RefObject<HTMLDivElement>}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={className}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-expanded={undefined}
            aria-haspopup="dialog"
            aria-disabled={disabled}
        >
            {children}
        </div>
    );
};
